/**
 * Foursource page
 * https://foursource.com/imprint
 */

import * as React from 'react';

import { withTrans } from '../i18n/withTrans';

import { pageTexts } from '../content/imprint';

// components
import Layout from '../components/layout';
import TitleSeparator from '../components/titleSeparator';
import Text from '../components/text';

class imprintPage extends React.Component {
  constructor(props) {
    super(props);
    this.t = props.t;
    this.text = pageTexts(this.t);
  }

  render() {
    return (
      <Layout pageName='imprint' headerWhite={true}>
        <div className='pt-menu'>
          <div className='paddingSidesBigger pb-75 pt-75'>
            <TitleSeparator info={this.text.topTitle}></TitleSeparator>
            <Text text={this.text.foursourceGroup}></Text>
            <hr></hr>
            <Text text={this.text.companyRegistration}></Text>
            <hr></hr>
            <Text text={this.text.disclaimer}></Text>
          </div>
        </div>
      </Layout>
    );
  }
}

export default withTrans(imprintPage);
